import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-components/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const AccountHistory = Loadable(lazy(() => import('views/history/account')));
const PushHistory = Loadable(lazy(() => import('views/history/push')));
const EventHistory = Loadable(lazy(() => import('views/history/event')));
const PlatformHistory = Loadable(lazy(() => import('views/history/platform')));
const StorageHistory = Loadable(lazy(() => import('views/history/storage')));
const Contract = Loadable(lazy(() => import('views/billing/contract')));
const Promotion = Loadable(lazy(() => import('views/billing/promotion')));
const Statement = Loadable(lazy(() => import('views/billing/statement')));
const StatementTest = Loadable(lazy(() => import('views/billing/statement-test')));
const MailTest = Loadable(lazy(() => import('views/manage/mail')));
const ForceUpdate = Loadable(lazy(() => import('views/manage/force-update')));
const Sticker = Loadable(lazy(() => import('views/manage/sticker')));
const MemberSearch = Loadable(lazy(() => import('views/search/member')));
const AccountSearch = Loadable(lazy(() => import('views/search/account')));
const TeamSearch = Loadable(lazy(() => import('views/search/team')));
const MemberBulk = Loadable(lazy(() => import('views/bulk/member')));
const OrganizationBulk = Loadable(lazy(() => import('views/bulk/organization')));

// sample page routing
// const SamplePage = Loadable(lazy(() => import('views/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

export const buildMainRoutes = (children) => {
    return {
        path: '/',
        element: <MainLayout />,
        children
    };
};

export const CHILDREN = [
    {
        path: '/',
        element: <DashboardDefault />
    },
    {
        path: 'dashboard',
        children: [
            {
                path: 'active',
                element: <DashboardDefault />
            }
        ]
    },
    {
        path: 'search',
        children: [
            {
                path: 'account',
                element: <AccountSearch />
            },
            {
                path: 'team',
                element: <TeamSearch />
            },
            {
                path: 'member',
                element: <MemberSearch />
            }
        ]
    },
    {
        path: 'billing',
        authority: 'BILLING_VIEW',
        children: [
            {
                path: 'contract',
                element: <Contract />
            },
            {
                path: 'promotion',
                element: <Promotion />
            },
            {
                path: 'statement',
                element: <Statement />
            },
            {
                path: 'statement-test',
                element: <StatementTest />
            }
        ]
    },
    {
        path: 'history',
        authority: 'HISTORY_VIEW',
        children: [
            {
                path: 'account',
                element: <AccountHistory />
            },
            {
                path: 'push',
                element: <PushHistory />
            },
            {
                path: 'event',
                element: <EventHistory />
            },
            {
                path: 'platform',
                element: <PlatformHistory />
            },
            {
                path: 'storage',
                element: <StorageHistory />
            }
        ]
    },
    {
        path: 'bulk',
        authority: 'BULK_VIEW',
        children: [
            {
                path: 'member',
                element: <MemberBulk />
            },
            {
                path: 'organization',
                element: <OrganizationBulk />
            }
        ]
    },
    {
        path: 'manage',
        children: [
            {
                path: 'forceUpdate',
                element: <ForceUpdate />
            },
            {
                path: 'mail',
                element: <MailTest />
            },
            {
                path: 'sticker',
                element: <Sticker />
            }
        ]
    }
];
